import CheckoutData from 'src/models/order/CheckoutData'
import Order, { ORDER_CHECKOUT_DEFAULT_OPTIONS } from 'src/models/order/Order'

export default async ({ app }) => {
  if (app.config.globalProperties.$consumer) {
    app.config.globalProperties.$checkoutData = new CheckoutData()
    app.config.globalProperties.$donationWidgetCheckoutData = new CheckoutData()
    app.config.globalProperties.$voucherWidgetCheckoutData = new CheckoutData()
    app.config.globalProperties.$giftCardWidgetCheckoutData = new CheckoutData()
    app.config.globalProperties.$order = new Order({}, ORDER_CHECKOUT_DEFAULT_OPTIONS)

    window.addEventListener('beforeunload', (e) => {
      if (app.config.globalProperties.$order.draftOrderItems.length > 0) {
        e.preventDefault()
        // Included for legacy support, e.g. Chrome/Edge < 119
        e.returnValue = true
      }
    })

    // 'pagehide' fires when the browser hides the current page in the process of presenting a different page from the session's history.
    // For example, when the user clicks the browser's Back button, the current page receives a pagehide event before the previous page is shown.
    window.addEventListener('pagehide', (event) => {
      // 'persisted' indicates if the document is loading from a cache
      // Does not fire on 'back'. Does fire for closing/reloading a tab. On mobile does not fire if the browser application is closed.
      if (!event.persisted) {
        app.config.globalProperties.$order.abandon()
      }
    })
  }
}
